import { Form } from 'factorial-form'
import { computed, makeObservable } from 'mobx'

import hasFeature from 'modules/core/lib/hasFeature'

import { RESET_FREQUENCIES } from 'modules/attendance/store/models/BalanceCarryover'

class BalanceCarryoverForm extends Form {
  constructor(values: Record<string, string | number | boolean | null | undefined>) {
    super(values, {
      id: 'number',
      effective_at: 'date',
      attendance_employees_setting_id: 'number',
      reset_frequency: 'string',
      custom_period_frecuency: 'string',
      frequency_number: 'number',
    })
    makeObservable(this, {
      frequencyNumber: computed,
      resetFrequency: computed,
      isValidFrequencyNumber: computed,
      showFrequencyNumber: computed,
      disableFrequencyNumber: computed,
    })
  }

  get resetFrequency(): string {
    return this.get('reset_frequency').value
  }

  get frequencyNumber(): number {
    return this.get('frequency_number').value
  }

  get isValidFrequencyNumber(): boolean {
    const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

    if (hasWeeklyBalanceCompensation) {
      if (this.resetFrequency !== RESET_FREQUENCIES.NEVER) return this.frequencyNumber > 0
    } else {
      if (this.resetFrequency === RESET_FREQUENCIES.CUSTOM_PERIOD) return this.frequencyNumber > 0
    }

    return true
  }

  get showFrequencyNumber(): boolean {
    const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

    if (hasWeeklyBalanceCompensation) {
      return this.resetFrequency !== RESET_FREQUENCIES.NEVER
    } else {
      return this.resetFrequency === RESET_FREQUENCIES.CUSTOM_PERIOD
    }
  }

  get disableFrequencyNumber(): boolean {
    const hasWeeklyBalanceCompensation = hasFeature('dev_time_tracking_weekly_balance_compensation')

    if (hasWeeklyBalanceCompensation) {
      return this.resetFrequency === RESET_FREQUENCIES.YEARLY
    } else {
      return false
    }
  }
}

export default BalanceCarryoverForm
